import { compose, lifecycle, withHandlers, withProps, withState } from 'recompose';
import { hot } from 'react-hot-loader';
import { withAxios } from 'op/components/auth';
import { withLocale } from 'op/components/locale';
import { Card, Header, Checkbox, Table, Button, Message } from 'semantic-ui-react';
import React from 'react';
import Test12 from '../form/form/tests-components/Test12';
import styled from 'styled-components';
import Test3 from '../form/form/tests-components/Test3';
import Test4 from '../form/form/tests-components/Test4';
import Test5 from '../form/form/tests-components/Test5';
import Test6 from '../form/form/tests-components/Test6';
import { useState } from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useMemo } from 'react';

const Collapsible = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;  
    align-items: center;
    background-color: white;
`;

const CollapsibleColumn = styled.div`
    flex: 1;
`;

const ThresholdsSTP = ({ thresholds, updateThresholds, loading, locale, updating }) => {
    const [stpForm, setStpForm] = useState({
        data: [view]
    });

    const history = useHistory();

    const [isMessageOpen, setIsMessageOpen] = useState(false);

    const isUpdateDisabled = useMemo(() => {
        if (!thresholds) {
            return true;
        }

        return thresholds.allowUpdate === false;
    }, [thresholds]);

    useEffect(() => {
        if (isMessageOpen) {
            setTimeout(() => {
                setIsMessageOpen(false);
                history.push('/stp');
            }, 3000);
        }
    }, [isMessageOpen]);

    useEffect(() => {
        const view = Object.fromEntries(Object.entries(thresholds).map(([key, value]) => [key.replace(
            'asM_', ''
        ), value]));

        view.STPTestView = 'STPTestView';
        delete view.allowUpdate;

        setStpForm({
            data: [view]
        })
    }, [thresholds]);

    const view = stpForm.data[0];

    return (
        <div>
            <h1>{locale.threshold}</h1>
            {loading && <div>{locale.loading}</div>}
            {view && <div>
                <Card fluid>
                    <Card.Content
                        className='content-padded-from-top  '
                    >
                        <Collapsible>
                            <CollapsibleColumn>
                                <Header>{locale.test12}</Header>
                                <Test12 view={view} setStpForm={setStpForm} />
                                <Header>{locale.test3}</Header>
                                <Test3 view={view} setStpForm={setStpForm} />
                                <Header>{locale.test4}</Header>
                                <Test4 view={view} setStpForm={setStpForm} />
                            </CollapsibleColumn>
                            <CollapsibleColumn>
                                <Header>{locale.test5}</Header>
                                <Test5 view={view} setStpForm={setStpForm} />
                                <Header>{locale.test6}</Header>
                                <Test6 view={view} setStpForm={setStpForm} />
                            </CollapsibleColumn>
                        </Collapsible>
                        <Button
                            loading={loading}
                            disabled={loading || updating || isUpdateDisabled}
                            onClick={() => updateThresholds(view, () => setIsMessageOpen(true))}
                            primary
                        >
                            {locale.save}
                        </Button>
                        <Message
                            hidden={!isMessageOpen}
                            positive
                            header={locale.success}
                            content={locale.successMessage}
                        />
                    </Card.Content>
                </Card>
            </div>}
        </div>
    );
}

export default compose(
    hot(module),
    withAxios,
    withState('thresholds', 'setThresholds', {}),
    withState('loading', 'setLoading', false),
    withState('updating', 'setUpdating', false),
    withHandlers({
        getThresholds: ({ setLoading, setThresholds, axios }) => async () => {
            setLoading(true);

            const { data } = await axios.get('/api/Stp/getStpThreshold');

            setThresholds(data);
            setLoading(false);
        },
        updateThresholds: ({ thresholds, setLoading, axios, setThresholds, cache }) => async (finalValues, callback) => {
            setLoading(true);

            const updateData = {
                asM_STPTest12_24_0: null,
                asM_STPTest12_24_48: null,
                asM_STPTest12_24_79: null,
                asM_STPTest12_24_111: null,
                asM_STPTest12_30_0: null,
                asM_STPTest12_30_48: null,
                asM_STPTest12_30_79: null,
                asM_STPTest12_30_111: null,
                asM_STPTest12_32_0: null,
                asM_STPTest12_32_48: null,
                asM_STPTest12_32_79: null,
                asM_STPTest12_32_111: null,
                asM_STPTest12_36_0: null,
                asM_STPTest12_36_48: null,
                asM_STPTest12_36_79: null,
                asM_STPTest12_36_111: null,
                asM_STPTest3_1H: null,
                asM_STPTest3_1V: null,
                asM_STPTest3_15H: null,
                asM_STPTest3_15V: null,
                asM_STPTest3_2H: null,
                asM_STPTest3_2V: null,
                asM_STPTest4_5: null,
                asM_STPTest4_10: null,
                asM_STPTest4_15: null,
                asM_STPTest5_14: null,
                asM_STPTest5_16: null,
                asM_STPTest5_18: null,
                asM_STPTest5_20: null,
                asM_STPTest5_22: null,
                asM_STPTest5_24: null,
                asM_STPTest5_26: null,
                asM_STPTest5_28: null,
                asM_STPTest5_30: null,
                asM_STPTest6_Salt: null,
                asM_STPTest6_Sugar: null,
            }

            Object.entries(finalValues).forEach(([key, value]) => {
                const changed = thresholds[`asM_${key}`] !== value;

                if (changed) {
                    updateData[`asM_${key}`] = value;
                }
            });

            await axios.post('/api/Stp/updateStpThreshold', updateData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            const { data } = await axios.get('/api/Stp/getStpThreshold', {
                clearCacheEntry: true
            });

            setThresholds(data);
            setLoading(false);
            callback();
        }
    }),
    withLocale('stp.threshold'),
    lifecycle({
        componentDidMount() {
            this.props.getThresholds();
        }
    })
)(ThresholdsSTP);
